export default {
  computed: {
    hasValidity() {
      return this.product.valid_from && this.product.valid_to
    },

    isTripsBalanceType() {
      return this.product.product_entity_balance_type === 'trips'
    },
  },

  methods: {
    formattedDate(date) {
      return moment(date).tz(this.administrativeArea.time_zone).format('DD/MM/YYYY')
    },
    supportTypeText() {
      return this.$t(
        `balance.products.productsData.supportEntityTypes.${this.product.support_entity_type}`
      )
    }
  }
}
